/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForDeviceConnectionCountersResponseElements
 */
export interface ReportForDeviceConnectionCountersResponseElements {
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceConnectionCountersResponseElements
     */
    dateHour: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeviceConnectionCountersResponseElements
     */
    count: number | null;
}

export function ReportForDeviceConnectionCountersResponseElementsFromJSON(json: any): ReportForDeviceConnectionCountersResponseElements {
    return ReportForDeviceConnectionCountersResponseElementsFromJSONTyped(json, false);
}

export function ReportForDeviceConnectionCountersResponseElementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceConnectionCountersResponseElements {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dateHour': json['dateHour'],
        'count': json['count'],
    };
}

export function ReportForDeviceConnectionCountersResponseElementsToJSON(value?: ReportForDeviceConnectionCountersResponseElements | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dateHour': value.dateHour,
        'count': value.count,
    };
}

